import React from 'react';
import './style.scss';

const PhotoDisplay = ({selectedPhoto, setSelectedPhoto }) => {
  return (
    <div className={'photo-display'}>
      <div className="photo">
        <button onClick={() => setSelectedPhoto(null)}>X</button>
        <img src={selectedPhoto}/>
      </div>
    </div>
  );
};

export default PhotoDisplay;
